module.exports = __webpack_public_path__ + "static/img/Silver Elite.9b95488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Silver Elite.png
// module id = aQBa
// module chunks = 35